import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class HeaderToggleButton {
  constructor($toggleButton) {
    this.$toggleButton = $toggleButton;
    this.$menu = document.getElementById(this.$toggleButton.getAttribute('aria-controls'));

    // Binded events
    this.bindedOnOverlayClose = this.onOverlayClose.bind(this);
    this.bindedOnCookieAccept = this.onCookieAccept.bind(this);
    this.bindedOnClick = this.onClick.bind(this);

    // Add events
    document.addEventListener('overlayClose', this.bindedOnOverlayClose);
    document.addEventListener('cookieAccepted', this.bindedOnCookieAccept);
    this.$toggleButton.addEventListener('click', this.bindedOnClick);
  }

  deconstructor() {
    // Remove events
    document.removeEventListener('overlayClose', this.bindedOnOverlayClose);
    document.removeEventListener('cookieAccepted', this.bindedOnCookieAccept);
    this.$toggleButton.removeEventListener('click', this.bindedOnClick);

    // Remove all calculated styling
    this.$menu.querySelector('.header__meta').removeAttribute('style');
    this.$menu.querySelector('.header__menu-logo-wrapper').removeAttribute('style');
    this.$menu.querySelector('.header__meta').cookie = false;

    // Reset panel
    this.closeMenu();
  }

  closeMenu() {
    // Change toggle button
    this.$toggleButton.setAttribute('aria-expanded', 'false');

    // Close menu
    this.$menu.classList.remove('open');

    // Re-enable scrolling
    enableBodyScroll(this.$menu);

    // Remove overlay class from body
    document.documentElement.classList.remove('has-overlay');

    // Add focus back on toggle button
    this.$toggleButton.focus();

    // Remove padding and height styles from mobile menu if cookie has been accepted
    const $cookie = document.querySelector('.alert');

    if (!$cookie) {
      this.$menu.querySelector('.header__meta').removeAttribute('style');
      this.$menu.querySelector('.header__menu-logo-wrapper').removeAttribute('style');
      this.$menu.querySelector('.header__meta').cookie = false;
    }
  }

  openMenu() {
    // Change toggle button
    this.$toggleButton.setAttribute('aria-expanded', 'true');

    // Make sure we're at top of page
    window.scrollTo(0, 0);

    // Disable scrolling
    disableBodyScroll(this.$menu);

    // Add overlay class to body
    document.documentElement.classList.add('has-overlay');

    // Show panel
    this.$menu.classList.add('open');

    // If cookie alert visible add more spacing to mobile menu
    const $cookie = document.querySelector('.alert');
    const $headerMeta = this.$menu.querySelector('.header__meta');
    const $headerLogoWrapper = this.$menu.querySelector('.header__menu-logo-wrapper');

    if ($cookie && !$headerMeta.cookie) {
      const defaultPadding = window.getComputedStyle($headerMeta, null).getPropertyValue('padding-top').match(/\d+/g)[0];
      const cookieHeight = $cookie.clientHeight;
      $headerMeta.style.paddingTop = `${cookieHeight + parseInt(defaultPadding, 10)}px`;
      $headerLogoWrapper.style.height = `${cookieHeight + $headerLogoWrapper.clientHeight}px`;
      $headerMeta.cookie = true;
    }
  }

  onOverlayClose() {
    // Close menu if event to close all overlays is fired
    window.requestAnimationFrame(() => this.closeMenu());
  }

  onCookieAccept() {
    // Remove cookie height from padding if cookieAccepted event is fired
    this.$menu.querySelector('.header__meta').removeAttribute('style');
    this.$menu.querySelector('.header__menu-logo-wrapper').removeAttribute('style');
  }

  onClick(event) {
    // Get current state of panel
    const isClosed = this.$toggleButton.getAttribute('aria-expanded') !== 'true';

    // Switch state
    window.requestAnimationFrame(() => {
      if (isClosed) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    });

    event.preventDefault();
  }
}
